import React, { Component } from 'react';

import TakeQuestionsForm from '../../forms/take-questions';
import Modal from '../../shared/modal';
import ToAnswer from '../../shared/to-answer';

import style from './index.module.scss';

class QuestionsForYou extends Component {
  state = {
    open: false,
  };

  onOpenModal = () =>
    this.setState({
      open: true,
    });

  onCloseModal = () =>
    this.setState({
      open: false,
    });

  render() {
    const { open } = this.state;
    const { message, icon, answer } = style;

    return (
      <>
        <div className={`card ${style['card--questions-for-you']}`}>
          <div className={`row ${style['take-questions']}`}>
            <div className={`col-12 ${style['col--top']}`}>
              <p className={message}>
                <i className={`fas fa-archive ${icon}`} />
                Start taking questions
              </p>
            </div>
            <div className={`col-12 ${style['col--bottom']}`}>
              <p className={message}>
                Tell your followers what kind of questions you want.
              </p>
              {!open ? (
                <span
                  onClick={this.onOpenModal}
                  className={style['get-started']}
                >
                  Get Started
                </span>
              ) : (
                <Modal
                  isModalOpen={open}
                  isFooterDisplayed={false}
                  openModal={this.onOpenModal}
                  closeModal={this.onCloseModal}
                  label="Start taking questions"
                >
                  <TakeQuestionsForm
                    currentUser={{
                      name: 'Collins A. Orlando',
                      imgUrl: 'https://i.imgur.com/qHpJwKV.jpg',
                    }}
                    closeModal={this.onCloseModal}
                  />
                </Modal>
              )}
            </div>
          </div>
        </div>
        <div className={`card ${style['card--questions-list']}`}>
          <div className={`col-12 ${style['col--top']}`}>
            <p className={message}>
              <i className={`fas fa-star ${icon}`} />
              Questions For You
            </p>
          </div>
          {[1, 2, 3, 4].map(x => (
            <div className={answer} key={x}>
              <ToAnswer
                questionTitle="How many years do we likely have left on this planet?"
                questionId={x.toString()}
                answersLength={4}
                updatedAt="2019-05-12T15:10:04.348Z"
              />
            </div>
          ))}
        </div>
      </>
    );
  }
}

export default QuestionsForYou;
